module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="splayer-body">\n  <audio class="splayer-audio" src="' +
((__t = ( audio.url )) == null ? '' : __t) +
'"' +
((__t = ( options.autoplay ? ' autoplay' : '' )) == null ? '' : __t) +
'' +
((__t = (  options.loop ? ' loop' : '' )) == null ? '' : __t) +
'></audio>\n  <div class="splayer-cover" ' +
((__t = ( audio.cover ? 'style="background-image: url(' + audio.cover + ');"' : '' )) == null ? '' : __t) +
'></div>\n  <div class="splayer-progress"></div>\n  <div class="splayer-mask" style="opacity: 1">\n    <div class="splayer-title">' +
((__t = ( audio.title )) == null ? '' : __t) +
'</div>\n    <div class="splayer-artist">' +
((__t = ( audio.artist )) == null ? '' : __t) +
'</div>\n    <div class="splayer-controller">' +
((__t = ( icons.play )) == null ? '' : __t) +
'</div>\n  </div>\n</div>\n';

}
return __p
}